import React, { Component } from 'react'
import { Switch, withRouter, Route } from 'react-router-dom'

import Clients from 'Containers/Clients'
import ClientView from 'Containers/Clients/ClientView'
import ClientAdd from 'Containers/Clients/ClientAdd'
import ClientEdit from 'Containers/Clients/ClientEdit'

import { AdminRoute, CityManagerRoute } from 'Config/Routing/auth'
import { PATHS } from 'Config/Routing/paths'

class ClientRouter extends Component {
  render() {
    return (
      <Switch>
        <Route path={this.props.match.url + PATHS.clients.add}>
          <AdminRoute>
            <ClientAdd />
          </AdminRoute>
        </Route>
        <Route path={this.props.match.url + PATHS.clients.edit}>
          <AdminRoute>
            <ClientEdit />
          </AdminRoute>
        </Route>
        <Route path={this.props.match.url + PATHS.clients.clientView}>
          <CityManagerRoute>
            <ClientView />
          </CityManagerRoute>
        </Route>
        <Route path={this.props.match.url}>
          <CityManagerRoute>
            <Clients />
          </CityManagerRoute>
        </Route>
      </Switch>
    )
  }
}

export default withRouter(ClientRouter)



// WEBPACK FOOTER //
// ./src/Config/Routing/ClientRouter.js